class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    // Find the 'details' element
    this.mainDetailsToggle = this.querySelector('details');

    // If no 'details' element is found, simply exit without any further processing
    if (!this.mainDetailsToggle) {
      // Optionally log for debugging (you can remove this in production)
      return; // Exit if no 'details' found
    }

    // Access the content associated with the summary
    this.content = this.mainDetailsToggle.querySelector('summary')?.nextElementSibling;

    // If no content is found after the summary, you might want to handle it similarly
    if (!this.content) {
      // Optionally log for debugging
      console.log('No content element found after summary in DetailsDisclosure; ignoring this instance.');
      return; // Exit if no content found
    }

    // Set up event listeners
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    }, 0);
  }

  onToggle() {
    // Check if animations exist
    if (!this.animations) {
      this.animations = this.content.getAnimations();
    }

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

// Register the custom elements
customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
